import { ICustomResponse, IUserAttributes } from '../interfaces/businessData';
import { DEFAULT_CUSTOM_RESPONSE_MOCK } from '../mocks/customResponse';
import { HttpService } from './http/httpService';

export class UpdateUserAttributes {
  static async update(attributes: IUserAttributes): Promise<string> {
    const response = await HttpService.post<ICustomResponse>(
      'users/attributes',
      attributes,
      {},
      DEFAULT_CUSTOM_RESPONSE_MOCK
    );
    const customResponse: ICustomResponse = response.data;
    return customResponse.message;
  }
}

export default UpdateUserAttributes;
